import { inferRouteObject } from 'react-router-typed-object';

import { Navigate } from '@/js/libs/router';
import { PrivateRoute, Roles } from '@/js/libs/use-auth';

import Status from 'src/scenes/Status/index.ts';
import { SupportChat } from 'src/scenes/SupportChat/index.ts';

const index = true;

export const supportChatRouteObject = inferRouteObject({
  path: 'support-chat',
  element: <PrivateRoute roles={Roles.SUPPORT_CHAT} noAccessComponent={Status.NotFound} />,
  children: [
    {
      Component: SupportChat.Helmet,
      children: [
        { index, element: <Navigate to='./new' replace /> },
        { path: ':convId', Component: SupportChat.Chat },
      ],
    },
  ],
});
